import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getStyles, translate } from '../../shared/utility';
import * as actions from '../../store/actions/index';

import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import Footer from '../../containers/Footer/Footer';
import Notifications from '../../components/UI/Notifications/Notifications';
import Modal from '../../components/UI/Modal/Modal';
import Button from '../../components/UI/Button/Button';
import Input from '../../components/UI/Input/Input';
import Login from '../../containers/User/Login/Login';
import Signup from '../../containers/User/Signup/Signup';

import userPlaceholder from '../../assets/images/img-contact-placeholder.svg';

import localStyles from './Layout.scss';
const styles = getStyles(localStyles);

class Layout extends Component {
    /* * * * * * * * *
     * REACT METHODS *
     * * * * * * * * */
    constructor(props) {
        super(props);
        this.state = {
            isSelectPaymentOpen: false,
            selectedPaymentId: null
        };

        this.refMainElement = React.createRef();
    }

    componentDidMount() {
        if(!!document.documentMode) {
            this.resizeHandler();
            window.addEventListener('resize', this.resizeHandler);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isAuthorized && !this.props.paymentAccountDetailsLoading) {
            if (!!this.props.paymentAccountDetailsData && this.state.isSelectPaymentOpen) {
                this.setState({ isSelectPaymentOpen: false });
            } else if (!!this.props.paymentAccountDetailsError) {
                if (!this.props.paymentAccountsData.length && !this.props.paymentAccountsError) {
                    this.props.onFetchPaymentAccounts();
                } else if (this.props.paymentAccountsData.length === 1) {
                    this.props.onUpdateUserPreferences(this.props.userData.id, 0, 'preferences/preferredPaymentAccountId');
                } else if (this.props.paymentAccountsData.length === 2) {
                    const businessAccount = this.props.paymentAccountsData.find(item => item.id !== 0);

                    this.props.onUpdateUserPreferences(this.props.userData.id, businessAccount.id, 'preferences/preferredPaymentAccountId');
                } else if(!this.state.isSelectPaymentOpen  && this.props.paymentAccountsData.length > 2) {
                    this.setState({ isSelectPaymentOpen: true });
                }
            }
        } else if (!this.props.isAuthorized && this.state.isSelectPaymentOpen) {
            this.setState({ isSelectPaymentOpen: false });
        }
    }

    componentWillUnmount() {
        if(!!document.documentMode) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }

    /* * * * * * * * * *
     * EVENT HANDLERS  *
     * * * * * * * * * */
    resizeHandler = () => {
        if(!!this.refMainElement && !!this.refMainElement.current) {
            this.refMainElement.current.style.top = `${this.getHeaderHeight()}px`;
            this.refMainElement.current.style.marginBottom = `${this.getHeaderHeight()}px`;
        }
    }

    handleChangePayment = (element) => {
        this.setState({ selectedPaymentId: parseInt(element.id, 10) });
    }

    handleSubmitPayment = (event) => {
        event.preventDefault();
        this.props.onUpdateUserPreferences(this.props.userData.id, this.state.selectedPaymentId, 'preferences/preferredPaymentAccountId');
        this.forceUpdate();
    }

    handleVoidActions = () => undefined;

    /* * * * * * * * * *
     * CUSTOM METHODS  *
     * * * * * * * * * */
    getHeaderHeight = () => Math.floor(document.getElementById('header').getBoundingClientRect().height);

    /* * * * * *
     * RENDER  *
     * * * * * */
    render() {
        const selectPaymentModal = this.state.isSelectPaymentOpen && this.props.paymentAccountsData.length ? (
            <Fragment>
                <p className={styles('c--text-light', 'line-height--small')}>
                    {translate('pages.paymentAccountModal.subtitle', this.props.language)}
                </p>
                <form onSubmit={this.handleSubmitPayment}>
                    <ul className={styles('layout__payment', 'no-list-style')}>
                        {this.props.paymentAccountsData.map(element => (
                            <li key={element.id} className={styles('layout__payment__item')}>
                                <Input
                                    attrs={{ type: 'radio' }}
                                    checked={this.state.selectedPaymentId === element.id}
                                    events={{ change: () => this.handleChangePayment(element) }}
                                    modifiers={['right']}
                                    labelClasses={styles('layout__payment__content')}
                                    labelContentClasses={styles('flex', 'flex--align-center')}
                                    loading={this.props.paymentAccountDetailsLoading || this.props.userPreferenceLoading}
                                >
                                    {!!element.imageReference || !!element.accountType === 'personal' ?
                                        <img src={!!element.imageReference ? element.imageReference.source : userPlaceholder} alt="" className={styles('layout__payment__image', 'layout__payment__image--border','circle')} /> :
                                        <div className={styles('layout__payment__image')}/>
                                    }
                                    <p className={styles('layout__payment__grow', 'line-height--small')}>
                                        <strong>{element.companyReference ? element.companyReference.name : this.props.userData.name}</strong>
                                        <br />
                                        <span>{element.accountType}</span>
                                    </p>
                                </Input>
                            </li>
                        ))}
                    </ul>
                    <Button
                        attrs={{type:'submit'}}
                        modifiers={['primary', 'stretch', 'm', 'spaced']}
                        disabled={!Number.isInteger(this.state.selectedPaymentId)}
                        loading={this.props.paymentAccountDetailsLoading || this.props.userPreferenceLoading}
                    >
                        {translate('ui.next', this.props.language)}
                    </Button>
                </form >
            </Fragment>
        ) : null;

        return (
            <Fragment>
                <Notifications />

                <Toolbar onVoid={this.handleVoidActions} />

                <Signup />

                <Login />

                {this.state.isSelectPaymentOpen && !!selectPaymentModal && this.props.paymentAccountsData.length ? (
                    <Modal
                        isOpen={this.state.isSelectPaymentOpen}
                        title={translate('pages.paymentAccountModal.title', this.props.language)}
                        noClosing={true}
                    >
                        {selectPaymentModal}
                    </Modal>
                ) : null}

                <main ref={this.refMainElement} className={styles('layout__main')} onClick={this.handleVoidActions}>
                    {this.props.children}
                </main>

                {this.props.isResultsOverviewActive ? null : <Footer onVoid={this.handleVoidActions} />}
            </Fragment>
        );
    }
}

Layout.propTypes = {
    // properties
    children: PropTypes.node.isRequired,

    isAuthorized: PropTypes.bool.isRequired,
    userData: PropTypes.object,
    isResultsOverviewActive: PropTypes.bool.isRequired,

    paymentAccountsData: PropTypes.arrayOf(PropTypes.object),
    paymentAccountsLoading: PropTypes.bool,
    paymentAccountsError: PropTypes.string,
    paymentAccountDetailsData: PropTypes.object,
    paymentAccountDetailsLoading: PropTypes.bool,
    paymentAccountDetailsError: PropTypes.string,
    userPreferenceLoading: PropTypes.bool,

    language: PropTypes.string.isRequired,

    // functions
    onUpdateUserPreferences: PropTypes.func.isRequired,
    onFetchPaymentAccounts: PropTypes.func.isRequired
};

const mapStateToProps = state => {
    return {
        isAuthorized: !!state.details.user.data,
        userData: state.details.user.data,
        isResultsOverviewActive: state.global.isResultsOverviewActive,

        paymentAccountsData: state.list.paymentAccounts.data,
        paymentAccountsLoading: state.list.paymentAccounts.loading,
        paymentAccountsError: state.list.paymentAccounts.error,
        paymentAccountDetailsData: state.details.paymentAccount.data,
        paymentAccountDetailsLoading: state.details.paymentAccount.loading,
        paymentAccountDetailsError: state.details.paymentAccount.error,
        userPreferenceLoading: state.condition.userPreference.loading,

        language: state.global.localization.language
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onUpdateUserPreferences: (userId, value, path) => dispatch(actions.updateUserPreferences(userId, value, path)),
        onFetchPaymentAccounts: () => dispatch(actions.fetchPaymentAccounts()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);



// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js